// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3XVtb","requiredAsterisk":"Info_requiredAsterisk__1vOfj"};